import { Directive, HostBinding, HostListener, Optional, SkipSelf } from "@angular/core";
import { CommonFieldManagerDirective } from "./field-manager.directive";

@Directive({
    selector: "[ngModel]",
})
export class FieldControlDirective {
    constructor( @SkipSelf() @Optional() public fieldManager: CommonFieldManagerDirective) { }

    @HostListener("blur")
    public touch() {
        if (!this.fieldManager) { return; }
        this.fieldManager.touch();
    }

    @HostBinding("class.is-invalid")
    public get isInvalid(): boolean {
        if (!this.fieldManager) { return false; }
        return this.fieldManager.isInvalid && this.fieldManager.touched;
    }
}
